import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import PaxValue from './PaxValue';

// @@@@@ 23-03-03 Komarov

// ##### Komarov 2025-07-14
const FrontHotelPaxResult = ({ className }) => {
  return (
    <div className={className} data-component="FrontHotelPaxResult">
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <PaxValue fontSize="1.6vh" />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <PaxValue fontSize="1rem" />
      </Media>
    </div>
  );
};

export default FrontHotelPaxResult;
